module.exports = __webpack_public_path__ + "static/media/Scanner.svg";